import Vue from 'vue';
import Vuetify from 'vuetify';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import 'vuetify/dist/vuetify.min.css';
import App from './App.vue';
import './slots-design.css';
Vue.use(Vuetify); Vue.use(VueRouter); Vue.use(Vuex);
import {store} from './services';
const router = new VueRouter({routes:[{path:'/',name:'workspace'},{path:'/login',name:'login'}]});
new Vue({router,store,vuetify:new Vuetify({theme:{themes:{light:{primary:'#0757b8'}}}}),render:h=>h(App)}).$mount('#app');
